module.exports = __webpack_public_path__ + "static/media/depositar.75810a99.svg";